import { isUserAuthorized } from './userHelpers';
import secureLog from './secureLogger';

export const constructSearchParamsFromUser = (publicData) => {
  const searchParams = new URLSearchParams();
  
  if (publicData.pub_practice_types || publicData.practice_types) {
    const practiceTypes = publicData.pub_practice_types || publicData.practice_types;
    const encodedPracticeTypes = Array.isArray(practiceTypes)
      ? practiceTypes.map(encodeURIComponent).join(',')
      : encodeURIComponent(practiceTypes);
    searchParams.append('pub_practice_types', `has_all:${encodedPracticeTypes}`);
  }
  
  if (publicData.pub_State || publicData.state) {
    const state = publicData.pub_State || publicData.state;
    const encodedState = encodeURIComponent(state);
    searchParams.append('pub_State', `has_all:${encodedState}`);
  }
  
  // Add default sort
  searchParams.append('sort', '-price');
  
  return searchParams;
};

export const handleExistingUserRedirect = (currentUser) => {
  secureLog.debug('User redirect helper', { 
    hasCurrentUser: !!currentUser,
    hasPublicData: !!currentUser?.attributes?.profile?.publicData || !!currentUser?.attributes,
    practiceTypesCount: (currentUser?.attributes?.profile?.publicData?.pub_practice_types || currentUser?.attributes?.pub_practice_types || []).filter(type => type !== 'Other' && type !== 'Tele').length || 0,
    hasPreferences: Boolean((currentUser?.attributes?.profile?.publicData?.pub_practice_types || currentUser?.attributes?.pub_practice_types || []).filter(type => type !== 'Other' && type !== 'Tele').length > 0 || (currentUser?.attributes?.profile?.publicData?.pub_State || currentUser?.attributes?.pub_State || '') !== '')
  });
  
  // Check if user has completed signup (has preferences)
  // Try both profile.publicData and direct attributes.publicData paths
  const publicData = currentUser?.attributes?.profile?.publicData || currentUser?.attributes;
  
  // Check both prefixed and non-prefixed versions of practice types
  const practiceTypes = publicData?.pub_practice_types || publicData?.practice_types;
  
  // Filter out "Other" and "Tele" from practice types
  const filteredPracticeTypes = Array.isArray(practiceTypes) 
    ? practiceTypes.filter(type => type !== 'Other' && type !== 'Tele')
    : undefined;
  
  // Check both prefixed and non-prefixed versions of state
  const state = publicData?.pub_State || publicData?.state;
  
  const hasPreferences = Boolean(
    (Array.isArray(filteredPracticeTypes) && filteredPracticeTypes.length > 0) || 
    state
  );
  
  if (hasPreferences) {
    const searchParams = new URLSearchParams();
    
    if (filteredPracticeTypes?.length > 0) {
      const encodedPracticeTypes = filteredPracticeTypes
        .map(encodeURIComponent)
        .join(',');
      searchParams.append('pub_practice_types', `has_all:${encodedPracticeTypes}`);
    }
    
    if (state) {
      const encodedState = encodeURIComponent(state);
      searchParams.append('pub_State', `has_all:${encodedState}`);
    }
    
    // Add default sort
    searchParams.append('sort', '-price');
    
    return `/s?${searchParams.toString()}`;
  }

  return '/getstarted';
}; 